import { takeLatest, put, call } from 'redux-saga/effects';
import { AxiosError } from 'axios';

import { User } from '@models/User';
import { getResponseError } from '@utils/error';
import { AuthApi, SignInWithOtpCodeAuthParams, SignInWithPasswordAuthParams } from '@apis/AuthApi';
import { history } from '@utils/history';
import { camDxSignIn } from '@components/CamDxPage/action';
import { CamDxApi } from '@apis/CamDxApi';

import { otpCodeSignIn, passwordSignIn, passwordSignInError, camDxSignInError } from './action';
import { SagaPayload } from '@utils/typescript';

function* handleOtpCodeSignIn({ payload }: SagaPayload<SignInWithOtpCodeAuthParams>) {
  const { mobileNumber } = (yield call(AuthApi.signInWithOtpCode, payload)) as User;
  history.navigate(`/sign-in/otp-code/${mobileNumber}`, { state: history.location.state });
}

function* handlePasswordSignIn({ payload }: SagaPayload<SignInWithPasswordAuthParams>) {
  try {
    const { mobileNumber } = (yield call(AuthApi.signInWithPassword, payload)) as User;
    history.navigate(`/sign-in/password/${mobileNumber}`, { state: history.location.state });
  } catch (e) {
    const { error } = getResponseError(e as AxiosError);
    yield put(passwordSignInError({ errors: { mobileNumber: error } }));
  }
}

function* handleCamDxSignIn() {
  try {
    const signInUrl = (yield call(CamDxApi.getSignInUrl)) as string;
    window.location.href = signInUrl;
  } catch ({ message }) {
    yield put(camDxSignInError({ errors: { camDx: message } }));
  }
}

export default function* () {
  yield takeLatest(camDxSignIn, handleCamDxSignIn);
  yield takeLatest(otpCodeSignIn, handleOtpCodeSignIn);
  yield takeLatest(passwordSignIn, handlePasswordSignIn);
}
